/**
 * The label for a trade row with no skills of its own.
 *
 * @param {number} [conditionalRuleCount] Skills whose conditional rules send work to it
 *   (always 0 while conditional trades are off, so that keeps a plain "No skills")
 * @returns {string}
 */
export function describeTradeWithoutSkills(conditionalRuleCount) {
    if (!conditionalRuleCount) return "No skills"
    return `No skills, used by conditional rules for ${conditionalRuleCount} ${"skill".pluralize(conditionalRuleCount)}`
}
